import VouchersReload from '@/components/VouchersReload'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		vouchers: [],
		...opts,
		vueComponent: VouchersReload
	}

	let page = vuewidget(dom, options)
	return page
}
